import {CombinedQuestionStats} from "../view-survey.types";
import {useMemo, useState} from "react";
import {AnswerSource} from "../../../redux/survey/survey.types";
import { maxAnswerPercentage, sortAnswers } from "./results-question.helpers";

const { AI, All, Human } = AnswerSource;
export const useResultsQuestion = (question: CombinedQuestionStats, aiMaxCompletes?: number, humanMaxCompletes?: number) => {
  const { answers, freeformAnswers } = question;
  const hasImageAnswers = answers.some(answer => answer.imageUrl);

  const { initialFilter, showFilters } = useMemo(() => {
    let initialFilt: AnswerSource = All;
    if (humanMaxCompletes === 0) {
      initialFilt = AI;
    } else if (aiMaxCompletes === 0) {
      initialFilt = Human;
    }
    return {
      initialFilter: initialFilt,
      showFilters: initialFilt === All,
    };
  }, [question, humanMaxCompletes, aiMaxCompletes]);


  const [answerFilter, setAnswerFilter] = useState<AnswerSource>(initialFilter);
  const { maxPercentage, sortedAnswers } = useMemo(() => {
    const sorted = question.freeformAnswers === undefined ? sortAnswers(answers, answerFilter) : [];
    return { maxPercentage: maxAnswerPercentage(answers, answerFilter), sortedAnswers: sorted };
  }, [answerFilter, answers]);

  return { hasImageAnswers, answerFilter, setAnswerFilter, showFilters, maxPercentage, sortedAnswers, freeformAnswers };
};
